// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.85.0-beta.2e799ff07',
  revision: '2e799ff07',
  branch: 'develop',
  date: 'Tue, 17 Feb 2026 19:28:16 GMT'
};